<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga">
                <div class="h3Organization mb-3">
                    <h3>Scores</h3>
                </div>
            </div>
            <div class="tab p-0">
                <router-link class="text-decoration-none tablinks h2 m-0" to="/user-score">Individual</router-link>
                <router-link class="text-decoration-none tablinks h2 m-0 active" to="/user-team-score" >Team</router-link>
            </div>
            <div class="tabcontent tabcontent-border-style">
                <div class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput">
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchTraining" maxlength="50">

                            <button @click="searchBackEndHandler" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>

                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="filterCompetitions">
                            <option value="false" selected disabled>Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>
                <div class="table-container" v-if="competitions.length > 0">
                    <TableComponent :thead="role === 'user' ? theadUser : thead"
                                    :tbody="competitions"
                                    @sort="SortTraining" :keys="role === 'user' ? keysUser : keys"
                                    model="score"
                                    name="score"
                                    updateUrl="" ids=""/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getTeamCompetition" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="text-center cssNoCompetitions">
                    <div class="mb-4">
                        <h2 class="">You Don't Have Any Scores Yet</h2>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import score from "../../../api-services/score";

    export default {
        name: 'training',
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'score');
            await this.getTeamCompetition();

        },
        data() {
            return {

                theadUser: ['#', 'Competition Name', 'score' , 'true or False' , 'Multiple Choice' , 'Free Text' , 'Slides'],
                keysUser: ['id', 'name', 'score' , 'scorePerQuestionTrueOrFalse', 'scorePerQuestionMultipleChoice', 'scorePerQuestionFreeText', 'scorePerQuestionSlides'],

                competitions: [],

                totalPages: 0,

                filteredArray: [],
                isActive1: true,
                isActive2: false,
                originalCompetitions: [],
                laravelData: {},

                searchType: 'team',

                search: '',
                sort: false,
                role: 'user'
            }
        },
        methods: {
            async getTeamCompetition(page = 1, search = false, sort='asc') {
                try {
                    this.competitions = [];
                    this.isActive1 = false;
                    this.isActive2 = true;
                    this.searchType = 'team';
                    this.theadUser = ['Competition Name', 'Number of Participants',  'True or False' , 'Multiple Choice' , 'Free Text' , 'Slides' ,'Rank', 'Arrange','Score' , 'Percentage' , 'Type'];
                    this.keysUser = ['name', 'users_count' , 'scorePerQuestionTrueOrFalse', 'scorePerQuestionMultipleChoice', 'scorePerQuestionFreeText', 'scorePerQuestionSlides' ,'scorePerQuestionRanks' , 'scorePerQuestionArrange', 'score' , 'percentage', 'type'];
                    const response = await score.getTeamCompetition(page, search, sort);
                    // console.log({response})
                    this.competitions = response.data.data;
                    // console.log( this.competitions.length)
                    this.laravelData = response.data;
                    this.originalCompetitions = response.data.data;
                    this.totalPages = response.data.meta.last_page;
                } catch (e) {
                    // console.log(e);
                    this.error = e;
                }
            },


            async SortTraining() {
                let status = !this.status2;
                this.originalCompetitions.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },

            searchTraining(e) {
                // let searchedValue = e.target.value;
                // let searchedData = this.originalCompetitions.filter((data) => data.name.includes(searchedValue));
                // this.competitions = searchedData;
            },
            async searchBackEndHandler() {
                // console.log(this.totalPages);
                // console.log(this.searchType);
                await this.getTeamCompetition(1, this.search);
            },

            async filterCompetitions(e) {
                await this.getTeamCompetition(1, this.search, e.target.value);
            }
        }
    }
</script>

<style scoped>

    .designRowOrga {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0;
        margin-bottom: 0;
    }

    /*.btnOrganization button {*/
    /*    background-color: #E95626;*/
    /*    color: #fff;*/
    /*    border: none;*/
    /*    border-radius: 5px;*/
    /*    justify-content: end;*/
    /*    align-content: center;*/
    /*    padding: 10px;*/
    /*}*/

    /*.cssBtnCreateCompetition {*/
    /*    background-color: #E95626;*/
    /*    color: #fff;*/
    /*    border-radius: 10px;*/
    /*    width: 200px;*/
    /*    padding: 10px;*/
    /*}*/

    .cssNoCompetitions {
        padding: 140px;
    }

    /*.btnInsideInput {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    border: 1px solid #FFF;*/
    /*    border-radius: 3px;*/
    /*}*/

    /*.btnInsideInput input {*/
    /*    border: none;*/
    /*}*/

    /*.btnInsideInput button {*/
    /*    background-color: #032431;*/
    /*    border: none;*/
    /*}*/

    /*.twoInputs #free_search {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    /*.btnSearchAll #searchAll {*/
    /*    background-color: #e65c00;*/
    /*    color: #fff;*/
    /*    width: 45px;*/
    /*    padding-left: 0px;*/
    /*    padding-right: 0px;*/
    /*    border-color: #e65c00;*/
    /*}*/

    /*.getScore #statusScore {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    /*.getStatus #statusSeacrh {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 350px;*/
    /*}*/

    /*.oneInput #filter_dates {*/
    /*    background-color: #032431;*/
    /*    color: #fff;*/
    /*    width: 220px;*/
    /*}*/

    /*.twoInputs {*/
    /*    display: flex;*/
    /*    flex-direction: row;*/
    /*    gap: 20px;*/
    /*}*/

    /*.fullInputs {*/
    /*    display: flex;*/
    /*}*/

    /*.fullInputs {*/
    /*    justify-content: space-between;*/
    /*}*/

    /*.tabcontent {*/
    /*    border: 1px solid #032431;*/
    /*    background-color: #032431;*/
    /*    border-radius: 0 20px 20px 20px;*/
    /*    padding: 23px;*/
    /*}*/

    /*.tab {*/
    /*    overflow: hidden;*/
    /*}*/

    /*.tab .tablinks {*/
    /*    background-color: inherit;*/
    /*    color: #fff;*/
    /*    float: left;*/
    /*    border: none;*/
    /*    outline: none;*/
    /*    cursor: pointer;*/
    /*    padding: 14px 16px;*/
    /*    transition: 0.3s;*/
    /*    font-size: 17px;*/
    /*}*/

    /*.tab .tablinks:hover,*/
    /*.tab .tablinks.active {*/
    /*    background-image: linear-gradient(#044D6B, #021A24);*/
    /*    color: #E37450;*/
    /*    border-radius: 10px 10px 0px 0px;*/
    /*}*/

    /*!*.tabcontent {*!*/
    /*!*    display: block;*!*/
    /*!*    padding: 30px;*!*/
    /*!*    height: 70vh;*!*/
    /*!*    border-top: none;*!*/
    /*!*    background-image: linear-gradient(#16303a, #021A24);*!*/
    /*!*    border-radius: 0 20px 20px 20px;*!*/
    /*!*}*!*/

    /*.setting-action {*/
    /*    text-decoration: none;*/
    /*    cursor: pointer;*/
    /*    background-color: #E95626;*/
    /*    border-radius: 10px;*/
    /*    color: #FFF;*/
    /*    border-radius: 4px;*/
    /*    font-weight: 500;*/
    /*    padding: 12px 55px;*/
    /*    font-size: 18px;*/
    /*    height: fit-content;*/
    /*}*/


    /*.setting-action:hover {*/
    /*    color: #FFF;*/
    /*}*/

    /*!* we will explain what these classes do next! *!*/
    /*.v-enter-active,*/
    /*.v-leave-active {*/
    /*    transition: opacity 0.5s ease;*/
    /*}*/

    /*.v-enter-from,*/
    /*.v-leave-to {*/
    /*    opacity: 0;*/
    /*}*/

    /*.back-route {*/
    /*    text-decoration: none;*/
    /*    cursor: pointer;*/
    /*    color: #FFF;*/
    /*    font-size: 22px;*/
    /*}*/

    /*.back-route:hover {*/
    /*    color: #FFF;*/
    /*}*/
</style>